import { service } from '@maia/cart';
import { queryOptions } from '@tanstack/react-query';

export function getUpsellproductsOptions(
  params: Parameters<typeof service.getUpsellproducts>[number],
) {
  return queryOptions({
    queryFn: () => service.getUpsellproducts(params),
    queryKey: ['upsellproducts', params.customerGuid],
  });
}
